export default __webpack_public_path__ + "static/media/Snd2.dfe2973f.mp3";